export default __webpack_public_path__ + "static/media/grama-esportiva6.4c7964e2.jpg";